import { getErrorMessage } from '../../utils/errorMessage';
import { useEffect, useState } from 'react';
import { ArrowRight, Loader2, Users } from 'lucide-react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { acceptTeamInvitationLink, getTeamInvitationLink, teamApiError } from './teamApi';
import './AccountCenterPage.css';

export default function TeamInvitationAcceptPage() {
  const { inviteId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [invitation, setInvitation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const authenticated = Boolean(localStorage.getItem('token'));

  useEffect(() => {
    let active = true;
    getTeamInvitationLink(inviteId).then(data => { if (active) setInvitation(data); }).catch(requestError => { if (active) setError(getErrorMessage(teamApiError(requestError, '邀请链接加载失败'))); }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [inviteId]);

  const accept = async () => {
    if (!authenticated) { navigate('/login', { state: { from: location.pathname } }); return; }
    setBusy(true); setError('');
    try { await acceptTeamInvitationLink(inviteId); navigate('/team/settings', { replace: true }); }
    catch (requestError) { setError(getErrorMessage(teamApiError(requestError, '接受邀请失败'))); setBusy(false); }
  };

  return <main className="team-accept-page"><section className="team-accept-card"><span className="team-accept-card__icon"><Users size={24} /></span>{loading ? <><h1>正在读取邀请</h1><Loader2 className="team-accept-card__spinner" size={20} /></> : error && !invitation ? <><h1>邀请链接不可用</h1><p role="alert">{error}</p><Link to="/home">返回首页</Link></> : <><span className="team-accept-card__eyebrow">团队邀请</span><h1>加入“{invitation?.team_name || '小影团队'}”</h1><p>加入后即可查看团队资源，并使用团队为你设置的 Tapies 额度。</p><dl><div><dt>团队 ID</dt><dd>{invitation?.public_team_id || '-'}</dd></div><div><dt>剩余名额</dt><dd>{invitation?.remaining_uses || 0} 次</dd></div></dl>{error && <p className="team-dialog__error" role="alert">{error}</p>}<button className="is-primary" type="button" disabled={busy} onClick={accept}>{busy ? <Loader2 size={14} className="team-accept-card__spinner" /> : <ArrowRight size={14} />}{authenticated ? (busy ? '正在加入…' : '接受邀请并加入') : '登录后接受邀请'}</button></>}</section></main>;
}
